import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="share"

// Connects to data-controller="share"
export default class extends Controller {
  static targets = ["result", "title", "body"];
  static values = { url: String }; // Best practice: use values for data attributes

  connect() {}

  async share(e) {
    e.preventDefault();

    const title = this.titleTarget.textContent;
    const body = this.bodyTarget.textContent;
    const url = this.urlValue || window.location.href;

    // Check if the Android Interface exists (injected by Kotlin)
    if (window.AndroidNative && window.AndroidNative.share) {
      try {
        window.AndroidNative.share(title, body, url);
        this.resultTarget.textContent = "Opening Android share...";
      } catch (err) {
        this.resultTarget.textContent = `Android Error: ${err}`;
      }
      return;
    }

    // Fallback for Standard Web Browsers (iOS Safari / Chrome / Desktop)
    if (navigator.share) {
      const shareData = { title, text: body, url }; // Note: 'body' usually maps to 'text' in API
      try {
        await navigator.share(shareData);
        this.resultTarget.textContent = "Deal has been shared!";
      } catch (err) {
        this.resultTarget.textContent = `Error: ${err}`;
      }
    } else {
      // Fallback for desktop browsers that don't support share
      // e.g. Copy to clipboard
      this.copyToClipboard(url);
    }
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      this.resultTarget.textContent = "Link copied to clipboard!";
    });
  }
}
